import { Box, Card, Stack, Typography } from '@mui/material';
import React from 'react';

interface EventHeaderProps {
    title: string;
    date: Date;
    organizerName: string;
}

function EventHeader({ title, date, organizerName }: EventHeaderProps) {
    return (
        <Card variant="outlined">
            <Box sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography gutterBottom variant="h5" component="div">
                        {title}
                    </Typography>
                    <Typography gutterBottom variant="h6" component="div">
                        {new Date(date).toLocaleDateString()}
                    </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                    {organizerName}
                </Typography>
            </Box>
        </Card>
    );
}

export default EventHeader;